<app-modal-component [open]="opeModal" [labelledBy]="titleId" [closeOnBackdrop]="true" (dismiss)="close()">
  <div class="sx">
    <header class="sx__head">
      <div class="sx__intro">
        <h2 class="bk-heading sx__title" [id]="titleId">Start from an existing segment</h2>
        <p class="sx__sub">Its conditions are copied into your new segment. The original does not change.</p>
      </div>
      <button type="button" class="bk-icon-btn" aria-label="Close" (click)="close()">
        <span class="bk-sym" aria-hidden="true">close</span>
      </button>
    </header>

    <div class="sx__toolbar">
      <app-search-input
        class="sx__search"
        placeholder="Search segments"
        [debounce]="350"
        (valueChange)="updateSearchTerm($event)"
      />
      <app-sort-dropdown
        [groups]="sortGroups"
        [selectedValue]="sortCriteria"
        panelAlign="right"
        (selectionChange)="updateSortCriteria($any($event))"
      />
    </div>

    @if (loadError) {
      <div class="sx__error" role="alert">
        <p>{{ loadError }}</p>
        <button type="button" class="bk-btn bk-btn--ghost" (click)="load()">Load again</button>
      </div>
    } @else {
      <select-existing-rule-table [segments]="segments" [loading]="loading" [searchTerm]="searchTerm" />
    }

    @if (!loadError && tagsPagination.totalElements > 0) {
      <div class="sx__pager">
        <app-pagination
          [currentPage]="tagsPagination.pageNumber"
          [totalPages]="tagsPagination.totalPages"
          [totalItems]="tagsPagination.totalElements"
          [pageSize]="pageSize"
          [loading]="loading"
          (changePage)="updateTagPage($event)"
          (onNext)="goToNextPage()"
          (onPrev)="goToPreviousPage()"
          (pageSizeChange)="onPageSizeChange($event)"
        />
      </div>
    }
  </div>
</app-modal-component>
